import type { CardHeaderProps } from "../types/layout.js";

export function CardHeader({ title, subtitle, action, children }: CardHeaderProps) {
  return (
    <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0 flex-1">
        <h2 className="text-base font-medium leading-snug">{title}</h2>
        {subtitle ? <p className="mt-2 text-sm leading-relaxed text-secondary-text">{subtitle}</p> : null}
        {children}
      </div>
      {action}
    </div>
  );
}
